import React from 'react'
import { SvgIcon } from '@mui/material'

export const CropIcon = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white' }}>
    <path
      fill="inherit"
      d="M7 17V1H5v4H1v2h4v10a2 2 0 0 0 2 2h10v4h2v-4h4v-2m-6-2h2V7a2 2 0 0 0-2-2H9v2h8v8Z"
    />
  </SvgIcon>
)
